// extracted by mini-css-extract-plugin
module.exports = {"viewerSwitchSelect":"SelectButton_viewerSwitchSelect__25qW8","viewerSwitchOn":"SelectButton_viewerSwitchOn__1ecSq","viewerSwitchOff":"SelectButton_viewerSwitchOff__qleWa"};